import { useState } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
// import authApi from "services/authApi";
import http from "services/httpClient";

interface AddClientModalProps {
  show: boolean;
  onClose: () => void;
  onClientAdded: (newClient: any) => void;
}

const AddClientModal = ({ show, onClose, onClientAdded }: AddClientModalProps) => {
  const [name, setName] = useState("");
  const [industry, setIndustry] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    // if (!name.trim() || !industry.trim()) {
    //   setError("Both fields are required.");
    //   setIsSubmitting(false);
    //   return;
    // }

    try {
      const { data } = await http.post(`/clients`, { name, industry });
      onClientAdded(data);
      onClose();
      setName("");
      setIndustry("");
    } catch (err : any) {
        // console.error("Client creation error:", err);

        if (err.response) {
            // console.error("Status:", err.response.status);
            // console.error("Data:", err.response.data);
            setError(`Error ${err.response.status}: ${err.response.data.detail || "Failed to add client."}`);
        } else if (err.request) {
            // console.error("No response received:", err.request);
            setError("No response from server.");
        } else {
            // console.error("Request setup error:", err.message);
            setError("Request error occurred.");
        }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Client</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="clientName" className="mb-3">
            <Form.Label>Client Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter client name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group controlId="industry" className="mb-3">
            <Form.Label>Industry</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter industry"
              value={industry}
              onChange={(e) => setIndustry(e.target.value)}
            //   required
            />
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onClose} className="me-2" disabled={isSubmitting}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={isSubmitting}>
              {isSubmitting ? <Spinner animation="border" size="sm" /> : "Add Client"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddClientModal;
